module.exports = __webpack_public_path__ + "img/258.operational.ec14f390.svg";